<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <!--<v-btn color="primary" outlined dark v-bind="attrs" v-on="on">
          <v-icon>mdi-plus</v-icon>
          Add Vessel
        </v-btn>-->
        <v-icon v-bind="attrs" v-on="on">mdi-arrow-up-bold-circle</v-icon>
      </template>
      <v-form
        id="new-item"
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="addCharges()"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Added Charges for DO # {{ do_number }}</span>
          </v-card-title>
          <!-- <v-card-text> -->
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" class="pt-2 mb-2">
                <v-text-field
                  label="Amount"
                  type="number"
                  value="amount"
                  v-model="amount"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pt-2 mb-2">
                <v-text-field
                  label="Final Charges(GMD)"
                  type="text"
                  value="final_charges"
                  v-model="final_charges"
                  disabled
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <v-col cols="12" sm="12" class="pt-2 mb-2">
              <v-textarea
                filled
                name="remark-textarea"
                label="Remark"
                value="remark"
                v-model="remark"
                outlined
              ></v-textarea>
            </v-col>
            <v-row> </v-row>
          </v-container>
          <!-- </v-card-text> -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" text :disabled="!dirty" type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { CommonServices } from "../../services/common.services";

const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");
const departedVesselName = createNamespacedHelpers("departed_vessels");

export default {
  props: ["do_number"],
  data: () => ({
    dialog: false,
    //vessels: "",
    do_id: null,
    amount: null,
    final_charges: 0,
    remark: null,
    delivery_time: null,
    activePicker: null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    modal: false,
    valid: true,
    errors: null,
    slug: "slug",
    error: false,
    nameRules: [v => !!v || "Item Name is required"],
    textRules: [v => !!v || "Field is required"]
  }),
  computed: {
    ...departedVesselName.mapState({
      setDepartureDateDialog: state => state.setDepartureDateDialog,
      selected_vessel: state => state.selected_vessel
    }),
    ...deliveryOrderNamespace.mapState({
      delivery_orders: state =>
        state.delivery_orders ? state.delivery_orders : [],
      delivery_order: state =>
        state.delivery_order ? state.delivery_order : [],
      loading: state => state.loading
    })
    /*dialog: {
      get(){
        return this.setDepartureDateDialog;
      },
      set(value){
        this.mUpdatesetDepartureDateDialog(value);
      }
    }*/
  },
  watch: {
    dialog(val) {
      //if (val) this.getVessels();
    }
    /*vessel(val) {
      val; // || this.close();

      if (val) {
        this.shipping_line = this.vessel.sline_name;
      }
    }*/
  },
  mounted() {
    //
  },

  methods: {
    ...deliveryOrderNamespace.mapActions(["setDelivery"]),
    dirty() {},

    async addCharges(item) {
      /* if (this.selected_vessel.departure_date != null) {
        this.$swal.fire({
          type: "error",
          title: "Oops...",
          text: "This vessel has already departed!"
        });
        this.close();
        return;
      }*/

      const data = {
        id: this.item.item.id,
        gatepass_number: this.gatepass_number,
        remark: this.remark,
        delivery_date: this.date,
        delivery_time: this.departure_time
      };

      if (data) {
        /* this.$store
          .dispatch("delivery_order/setDelivery", data)
          .then(() => {
            this.$noty.success("action successful");
            this.close();
          })
          .catch(({ response }) => {
            this.errors = response.data;
          });*/
      }
      console.log("items", data);
    },
    close() {
      this.dialog = false;
      this.clear();
    },
    clear() {
      this.departure_time + null;
    }
  }
};
</script>
